import { DynamicPhoneNumber } from './components/DynamicPhoneNumber/DynamicPhoneNumber';
import { getDynamicNumber } from './graphql/getDynamicNumber';

export { getDynamicNumber, DynamicPhoneNumber };

export type {
    Mutation,
    MutationCreateDynamicAgentPhoneArgs
} from './graphql/graphql.generated';
